import React, { useState, Fragment } from "react";
import clsx from 'clsx';
import { Link } from "react-router-dom"
import customStyles from "../../../assets/styles/customStyles";
import { Row, Col } from "antd";
import { checkPermission } from '../../../helpers/utilities';
import { purchaseMenus } from "../../../config/constant";
import { Top10Supplier, ResaleValueReport } from "../../Shared/components/ReportEnquiry";



const Menus = (props) => {
    const [topSupplierVisible, setTopSupplierVisible] = useState(false);
    const [resaleValueVisible, setResaleValueVisible] = useState(false);
    const [menuTitle, setMenuTitle] = useState('');
    const classes = customStyles();
    const { menuHeight } = props;
    const handleMenuOnClick = (name) => {
        setMenuTitle(name);
        if (name === 'Top 10 Suppliers') {
            setTopSupplierVisible(true);
        } else if (name === 'Resale Value Report') {
            setResaleValueVisible(true);
        }
    }
    return (
        <div className={clsx(classes.primaryPaper, classes.primaryMenu)} style={{ height: 'calc(100% - ' + menuHeight + 'px)', overflow: "auto" }}>
            <div style={{ height: '100%', overflow: "hidden" }}>
                <Row gutter={16}>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{purchaseMenus.sub[0].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {purchaseMenus.sub[0].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Purchase') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{purchaseMenus.sub[1].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {purchaseMenus.sub[1].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Purchase') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{purchaseMenus.sub[2].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {purchaseMenus.sub[2].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Purchase') &&
                                        <Fragment key={i}>
                                            {
                                                menus.onClick ? <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                                    <Link to={menus.link} onClick={() => handleMenuOnClick(menus.menu)} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                </div> : <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                                    <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                                </div>
                                            }
                                        </Fragment>
                                    )
                                })}
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <h5 type="secondary" className={classes.subMenuLinkTitle}>{purchaseMenus.sub[3].menu}</h5>
                        <div className={clsx(classes.subMenuLinks)}>
                            <div>
                                {purchaseMenus.sub[3].sub.map((menus, i) => {
                                    return (
                                        checkPermission(menus.menu, 'Purchase') && <div key={i} className={clsx(classes.margin10t, 'menuCheck')}>
                                            <Link to={menus.link} className={clsx(classes.color, classes.bold)}>{menus.menu}</Link>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
                <Top10Supplier
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={topSupplierVisible}
                    onTopSupplierVisible={(v) => setTopSupplierVisible(v)} />
                <ResaleValueReport
                    onMenuTitle={() => setMenuTitle('')}
                    title={menuTitle}
                    visible={resaleValueVisible}
                    onResaleValueVisible={(v) => setResaleValueVisible(v)} />
            </div>
        </div>
    )
}

export default Menus